import React, { useState, useEffect } from "react";
import { Col, Row, Button, InputGroup, FormControl, Alert } from "react-bootstrap";
import SeekersNetworkList from "../../../Components/SeekersNetworkList";
import getSeekersNetworkList from "../../../Services/SeekersNetworkService";
import alphabates from "../../../Components/AlphabatesSorting";
import ListPagination from "../../../Components/Pagination";
import { FaCommentAlt, FaSearch, FaQuestionCircle } from "react-icons/fa";
import SearchSeekersNetwork from "../../../Components/SearchSeekersNetwork";
import { getJobSeekerNetworkList } from "../../../Services/JobSeekersService";
import SpinnerLoader from "../../../Components/SpinnerLoader";
import { jobseekerNetworkPerPage } from "../../../Utilities/Helper";
import { getIndustry, getUserGroups } from "../../../Services/GetFields";
import { globalSearchAction } from "../../../Redux/GlobalSearch/Action";
import { useDispatch, useSelector } from "react-redux";

export default function Network() {
  //Using Redux
  const store = useSelector((res) => res.GlobalSearchReducer.networks);
  const [SeekersNetwork, setSeekersNetwork] = useState([]);
  const [totalNetwork, setTotalNetwork] = useState([]);
  const [currentPage, setCurrentPage] = useState({ value: "", filter: "" });
  const [refreshTable, setRefreshTable] = useState(true);
  const [showSpinner, setShowSpinner] = useState(true);
  const [industries, setIndustries] = useState([]);
  const [groups, setGroups] = useState([]);
  const [searchParams, setSearchParams] = useState("");
  const [showPagination, setShowPagination] = useState(true);
  const [showHelp, setShowHelp] = useState(false);
  // const [groupID, setGroupID] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    async function allIndustries() {
      getIndustry()
        .then((res) => {
          const result = JSON.parse(res.response);
          setIndustries(result);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    allIndustries();
  }, []);

  // getting Network list
  useEffect(() => {
    async function allGroups() {
      getUserGroups()
        .then((res) => {
          // console.log(res.response);
          setGroups(res.response);
          // setGroupID(res.response.groupId);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    async function seekersNetworkData() {
      setShowPagination(true);
      const filter =
        "PageSize=" +
        jobseekerNetworkPerPage +
        currentPage.filter +
        searchParams;
      // console.log(filter);
      getJobSeekerNetworkList(filter)
        .then((res) => {
          if (res.response === "" || res.response === null) {
            setShowSpinner(false);
            setSeekersNetwork([]);
            setTotalNetwork(0);
          } else {
            const response = JSON.parse(res.response);
            setShowSpinner(false);
            setSeekersNetwork(response.networkModels);
            setTotalNetwork(response.totalRecord);
          }
        })
        .catch((err) => {
          setShowSpinner(false);
          console.log(err);
        });
    }
    if (store === null) {
      seekersNetworkData();
    } else {
      setShowSpinner(true);
      setSeekersNetwork(store.items);
      setTotalNetwork(store.totalRecord);
      setShowSpinner(false);
    }
    allGroups();
  }, [refreshTable, store]);

  const pageChangeHandler = (page) => {
    if (currentPage.value !== page) {
      setCurrentPage((prev) => ({
        value: page,
        filter: `&PageNumber=${page}`,
      }));
      refreshTableHandler(page);
    }
  };

  const refreshTableHandler = (page = 0) => {
    if (store !== null && page !== 0) {
      dispatch(
        globalSearchAction({
          recordperpage: store.recordperpage,
          page: currentPage.value,
          type: store.type,
          SerachText: store.SerachText,
          GlobalSearchTypeId: store.GlobalSearchTypeId,
          searchTypeText: store.searchTypeText,
        })
      );
      setShowSpinner(true);
    } else {
      setRefreshTable((prev) => !prev);
      setShowSpinner(true);
      dispatch(
        globalSearchAction({
          type: "clear",
        })
      );
    }
  };

  const onSerchParamHandler = (params) => {
    setShowPagination(false);
    setSearchParams(params);
    setCurrentPage((prev) => ({ value: "", filter: "" }));
    refreshTableHandler();
  };

  const setRefresh = (val) => {
    if (val) {
      // console.log(val);
      refreshTableHandler();
    }
  };

  return (
    <div className="container p-0">
      <div className="header-with-search">
        <h1 className="page-title">
          Network
          <Button
            variant="link"
            className="p-0 ml-3 d-inline-flex align-items-center"
            onClick={() => setShowHelp(!showHelp)}
            title="How does Networking work?"
          >
            <FaQuestionCircle size={24} className="text-info" />
            <span className="text-info ml-2" style={{ fontSize: '1rem', fontWeight: 'normal' }}>Help</span>
          </Button>
        </h1>

      </div>
      {showHelp && (
        <Alert
          variant="info"
          className="my-4"
          dismissible
          onClose={() => setShowHelp(false)}
        >
          <Alert.Heading>How Networking Works</Alert.Heading>
          <p>
            A job seeker does not need to be a member of the group to apply for a job posting and/or post a public resume. A job seeker must be "Sponsored" (see "Sponsorships" option below) to Network.
          </p>
          <p>
            Select your Industry and choose "Search". Employed members of your group will be shown along with the employed member's Company and Position at the Company. Select "Request" beside those employed members who, given your skill set, would likely have helpful employment ideas, tips, or contacts. Attach your resume (see "My Resume" option below) and click "Send Resume". The employed member will review your résumé and respond with one of three options:
          </p>
          <ol>
            <li>Please have job seeker contact me at the following email address.</li>
            <li>Here is some information that may be helpful.</li>
            <li>I'm not aware of any opportunities for this job seeker.</li>
          </ol>
          <p className="mb-0">
            You may request 10 "Network" contacts per week.<br />
            Good Luck!
          </p>
        </Alert>
      )}
      <div className="dashboard-wrapper">
        <Row>
          <Col md={12}>
            <div className="dashboard-box dashboard-col-bg sponsership-page network-page">
              <SearchSeekersNetwork
                industriesList={industries}
                groupsList={groups}
                searchParam={onSerchParamHandler}
              />

              <div className="d-flex mb-3">
                <SeekersNetworkList networks={SeekersNetwork}
                  setRefresh={setRefresh} />
              </div>
              {showSpinner && <SpinnerLoader />}
              {SeekersNetwork.length === 0 &&
                // SeekersNetwork.length === 0 &&
                !showSpinner && (
                  <h5 style={{ textAlign: "center" }}>No Data Found</h5>
                )}
              {SeekersNetwork.length !== 0 && showPagination && (
                <ListPagination
                  recordPerPage={jobseekerNetworkPerPage}
                  TotalRecord={totalNetwork}
                  className="mt-3"
                  onPageChange={pageChangeHandler}
                />
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
// export default Network;
